export default {
  // Aqua-specific breadcrumb variant - matches the existing styling
  aqua_account: {
    container: "mb-6",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-gray_2",
    current: "flex items-center text-primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-2",
    separatorIcon: "w-4 h-4",
  },

  // Compact version for smaller spaces
  aqua_compact: {
    container: "mb-4",
    list: "flex items-center space-x-1 text-xs",
    item: "flex items-center",
    itemContent: "flex items-center space-x-1",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-gray_2",
    current: "flex items-center text-primary font-medium",
    icon: "w-3 h-3 mr-1 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-1",
    separatorIcon: "w-3 h-3",
  },

  // Large version for important navigation areas
  aqua_prominent: {
    container: "mb-8",
    list: "flex items-center space-x-3 text-base",
    item: "flex items-center",
    itemContent: "flex items-center space-x-3",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer font-medium",
    text: "flex items-center text-gray_2 font-medium",
    current: "flex items-center text-primary font-semibold",
    icon: "w-5 h-5 mr-2 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-3",
    separatorIcon: "w-5 h-5",
  },
}